// theme.js
export const blueTheme = {
  body: "#ffffffff",
  text: "#001C55",
  expTxtColor: "#000a12",
  highlight: "#ebebeb73",
  dark: "#00072D",
  secondaryText: "#656e80ff",
  imageHighlight: "#0E6BA8",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#0A2472",
  headerColor: "#1f2937",
  splashBg: "#001C55",
};

export const chosenTheme = blueTheme;
